var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 188,
    viewBox: "0 0 188 188",
    width: 188,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m187.968 94c0-51.9154-42.077-94-93.9838-94-51.9054 0-93.9842 42.0846-93.9842 94 0 51.915 42.0788 94 93.9842 94 51.9068 0 93.9838-42.085 93.9838-94z",
    fill: "#e89806"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.9523 109.789h-11.9364c-2.3638 0-4.2801-1.916-4.2801-4.281v-54.0498c0-2.3652 1.9163-4.2814 4.2801-4.2814h11.9364c2.3637 0 4.2817 1.9162 4.2817 4.2814v54.0498c0 2.365-1.916 4.281-4.2817 4.281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.9841 143.866c-5.6599 0-10.2483-4.59-10.2483-10.25v-.003c0-5.66 4.5884-10.25 10.2483-10.25s10.2499 4.59 10.2499 10.25v.003c0 5.66-4.59 10.25-10.2499 10.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarningIcon);
export default __webpack_public_path__ + "static/media/toast-warning-icon.0d016b71a9507007d98bd7f79dbb9aea.svg";
export { ForwardRef as ReactComponent };